﻿import React from 'react';
import PropTypes from 'prop-types';

export default class RadioButton extends React.Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(val) {
        this.props.onChange(val.target.value);
    }

    render() {
        return (
            <div className={`custom-control custom-radio${this.props.inline ? " custom-control-inline" : ""}`}>
                <input
                    role="radio"
                    aria-checked={this.props.checked}
                    type="radio"
                    id={this.props.id}
                    name={this.props.name}
                    className="custom-control-input"
                    checked={this.props.checked}
                    onChange={this.onChange}
                    value={this.props.value}
                />
                <label className="custom-control-label" htmlFor={this.props.id}>{this.props.label}</label>
            </div>
        );
    }
}

RadioButton.propTypes = {
    checked: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired
};